/**
 * Loading Reducer
 */
import { SET_LOADING, SET_GET_LOADING, SET_COMMON_POPUP, CLOSE_COMMON_POPUP, SET_COMMON_DIALOG, CLOSE_COMMON_DIALOG } from 'Actions/types';

const INITIAL_STATE = {
  isLoading: false,
  isGetLoading: false,
  popupData: { show: false, needIntl: true },
  dialogData: { show: false, needIntl: true },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_LOADING:
      return { ...state, isLoading: action.payload };
    case SET_GET_LOADING:
      return { ...state, isGetLoading: action.payload };
    case SET_COMMON_POPUP:
      return { ...state, popupData: action.payload };
    case CLOSE_COMMON_POPUP:
      return { ...state, popupData: INITIAL_STATE.popupData };
    case SET_COMMON_DIALOG:
      return { ...state, dialogData: action.payload };
    case CLOSE_COMMON_DIALOG:
      return { ...state, dialogData: INITIAL_STATE.dialogData };
    // default case
    default:
      return { ...state };
  }
};
